export default __webpack_public_path__ + "3e8099b8defb3528c552d5f875e926e8.png";